import {
    Component,
    Host,
    h,
    Element,
    Prop,
    ComponentInterface,
} from "@stencil/core";

@Component({
    tag: "ux-iws-teaser-download-document",
    styleUrl: "teaser-download-document.scss",
})
export class DownloadTeaser implements ComponentInterface {
    private baseClass = "ux-iws-teaser-download-document";

    @Element() domNode: HTMLUxIwsTeaserDownloadDocumentElement;

    /** link to the download  */
    @Prop() link: string;

    /** a11y-label for the download link */
    @Prop() downloadLabel: string = "";

    /** file size of the download */
    @Prop() fileSize: string = "";

    /** file type of the download */
    @Prop() fileType: string = "";

    /** additional file info of the download - e.g. changed date */
    @Prop() fileInfo: string = "";

    render() {
        return (
            <Host>
                <ux-iws-link-wrapper class={this.baseClass}>
                    <div class={`${this.baseClass}__inner`}>
                        <div class={`${this.baseClass}__image`}>
                            <div class={`${this.baseClass}__image-outer`}>
                                <div class={`${this.baseClass}__image-inner`}>
                                    <slot name="image"></slot>
                                    {this.fileType !== "" && (
                                        <div
                                            class={`${this.baseClass}__image-overlay`}
                                        >
                                            {this.fileType}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div class={`${this.baseClass}__content`}>
                            {this.fileInfo !== "" && (
                                <div class={`${this.baseClass}__info`}>
                                    {this.fileInfo}
                                </div>
                            )}
                            {this.fileSize !== "" && (
                                <div class={`${this.baseClass}__size`}>
                                    {this.fileSize}
                                </div>
                            )}
                            <div class={`${this.baseClass}__title`}>
                                <slot name="title"></slot>
                            </div>
                            <div class={`${this.baseClass}__description`}>
                                <slot name="description"></slot>
                            </div>
                        </div>
                        <a
                            class={`${this.baseClass}__link ux-button ux-button--icon-only`}
                            data-testid="download"
                            href={this.link}
                            download=""
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={this.downloadLabel}
                            title={this.downloadLabel}
                        >
                            <ux-icon name="download"></ux-icon>
                        </a>
                    </div>
                </ux-iws-link-wrapper>
            </Host>
        );
    }
}
